import { ChatBubbleBottomCenterTextIcon } from '@heroicons/react/24/outline';
import type { AppointmentOriginEvent } from '../../../services/adminAppointments';
import { ORIGIN_EVENT_RENDERERS } from './originEventRenderers';

interface OdoNoteCardProps {
    patientId: string;
    originEvent: AppointmentOriginEvent;
}

/** "ODO note": the timeline event that prompted the appointment, rendered per `type` via
 *  originEventRenderers/. Read-only port of the dashboard Composer's OdoContextCard. */
export function OdoNoteCard({ patientId, originEvent }: OdoNoteCardProps) {
    const renderer = ORIGIN_EVENT_RENDERERS[originEvent.type];
    if (!renderer || !renderer.hasContent(originEvent.payload)) return null;

    const EventComponent = renderer.Component;

    return (
        <div className="rounded-lg bg-amber-50 border border-amber-200 px-3.5 py-3">
            <div className="flex items-center gap-1.5 mb-1.5">
                <ChatBubbleBottomCenterTextIcon className="w-3.5 h-3.5 text-amber-600 flex-shrink-0" />
                <span className="text-[11px] font-semibold text-amber-700 uppercase tracking-wide">
                    ODO note :
                </span>
            </div>
            <EventComponent patientId={patientId} payload={originEvent.payload} />
        </div>
    );
}
